import { Injectable } from '@angular/core'
import { ConfigurationService, IAppSettings } from '../configuration/configuration.service';

@Injectable({ providedIn: 'root' })
export class AuditingService {

  constructor(private config: ConfigurationService<IAppSettings>) { }

  public addAuditingTrail(...objects: any[]): void {
    const currentUser = this.config.getValue('UserName');
    if (currentUser) {
      for (let i = 0; i < objects.length; i++) {
        if (Array.isArray(objects[i])) {
          for (let j = 0; j < objects[i].length; j++) {
            objects[i][j].updatedBy = currentUser;
          }
        }
        else {
          objects[i].updatedBy = currentUser;
        }
      }
    }
  }
}
